<template>
  <div class="seniorclass-container">
    <div class="seniorclass-container_ cen">
      <Breadcrumb>
        <BreadcrumbItem to="/">首页</BreadcrumbItem>
        <BreadcrumbItem :to="{ path: '/about', query: { cid: fid } }">关于金色年华</BreadcrumbItem>
        <BreadcrumbItem to="/seniorclass">长者课堂</BreadcrumbItem>
        <BreadcrumbItem>{{currentClassName.classname}}</BreadcrumbItem>
      </Breadcrumb>
      <div class="inside-main">
        <div class="seniorclass-detail">
          <div class="seniorclass-detail-img" v-if="detailInfo.picurl">
            <img :src="domainNameH5 + '/' + detailInfo.picurl" width="100%" alt="">
          </div>
          <div class="seniorclass-detail-cont">
            <div class="seniorclass-detail-item">{{detailInfo.title}}</div>
            <div class="seniorclass-detail-info">
              <span>发布人：{{detailInfo.author}}</span>
              <span>发布时间：{{detailInfo.posttime}}</span>
            </div>
            <div class="detail-cont" v-html="detailInfo.content"></div>
            <div class="detail-back" @click="backList">返回</div>
          </div>
        </div>
        <div class="inside-left-nav">
          <div class="left-nav-head">
            <div class="chname">关于金色年华</div>
            <div class="enname">{{fname.classname_en}}</div>
          </div>
          <div class="left-nav-list">
            <div class="left-nav-li" v-for="item in getsort" :key="item.id">
              <router-link :to="{ path: '/about', query: { cid: item.id } }" class="left-nav-link">
                <div class="chname">{{item.classname}}</div>
                <div class="enname">{{item.classname_en}}</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li">
              <router-link to="/publicwelfare" class="left-nav-link">
                <div class="chname">{{publicwelfarename.classname}}</div>
                <div class="enname">{{publicwelfarename.classname_en}}</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li active">
              <router-link to="/seniorclass" class="left-nav-link">
                <div class="chname">{{seniorclassname.classname}}</div>
                <div class="enname">{{seniorclassname.classname_en}}</div>
                <span></span>
              </router-link>
              <div class="left-subnav">
                <div class="left-subnav-li" v-for="item in lesson" :key="item.id" :class="[ item.id == cid ? 'active' : '']">
                  <router-link :to="{ path: '/seniorclass', query: { cid: item.id } }" class="left-subnav-link">{{item.classname}}</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHeaderData, getSeniorClassBasicData, getSeniorClassDetailData } from '../../api/getData.js'
export default {
  name: 'seniorClassDetail',
  data () {
    return {
      headerInfo: {},
      fid: '',
      page: 1,
      cid: '',
      id: '',
      pname: '',
      currentClassName: '',
      fname: {},
      publicwelfarename: {},
      seniorclassname: {},
      getsort: [],
      lesson: [],
      detailInfo: {}
    }
  },
  metaInfo () {
    return {
      title: this.headerInfo.title,
      meta: [
        { name: 'generator', content: this.headerInfo.generator },
        { name: 'author', content: this.headerInfo.author },
        { name: 'keywords', content: this.headerInfo.keywords },
        { name: 'description', content: this.headerInfo.description }
      ]
    }
  },
  watch: {
    '$route': function () {
      this.cid = this.$route.query.cid === undefined ? '' : this.$route.query.cid
      this.id = this.$route.query.id === undefined ? '' : this.$route.query.id
      this.page = this.$route.query.page === undefined ? 1 : this.$route.query.page
      this.getSeniorClassDetailInfo()
    }
  },
  created () {
    this.cid = this.$route.query.cid === undefined ? '' : this.$route.query.cid
    this.id = this.$route.query.id === undefined ? '' : this.$route.query.id
    this.page = this.$route.query.page === undefined ? 1 : this.$route.query.page
    this.getSeniorClassBasicInfo(this.cid)
    this.getSeniorClassDetailInfo()
  },
  methods: {
    async getHeaderInfo () {
      let postData = { cid: this.cid, id: this.id }
      let header = await getHeaderData(postData)
      this.headerInfo = header.header
      this.$store.dispatch('SetActiveMenu', { activeMenu: 'about', activeSendMenu: 'seniorclass' }).then(() => {}).catch(() => {})
    },
    async getSeniorClassBasicInfo (cid) {
      let postData = {}
      if (cid !== '') {
        postData.cid = cid
      }
      let result = await getSeniorClassBasicData(postData)
      this.fid = result.fid
      this.cid = result.cid
      this.fname = result.fname
      this.publicwelfarename = result.publicwelfarename
      this.seniorclassname = result.seniorclassname
      this.getsort = result.aboutus
      this.lesson = result.lesson
    },
    async getSeniorClassDetailInfo () {
      let postData = {}
      postData.cid = this.cid
      postData.id = this.id
      let result = await getSeniorClassDetailData(postData)
      this.currentClassName = result.cname
      this.detailInfo = result.info
      this.getHeaderInfo()
    },
    backList () {
      this.$router.push({ path: '/seniorclass', query: { cid: this.cid, page: this.page } })
    }
  }
}
</script>

<style scoped lang="less">
  .seniorclass-container_{
    padding-bottom: 60px;
  }
  .seniorclass-detail{
    width: 77.22%;
    padding: 0 66px;
    background-color: #ffffff;
    box-shadow: 0px 0px 13px 0px rgba(37, 37, 37, 0.15);
    border-radius: 5px;
    .seniorclass-detail-cont{
      padding: 0 0 80px;
      .seniorclass-detail-item{
        margin-top: 60px;
        font-size: 36px;
        line-height: 36px;
        color: #e76321;
        font-weight: bold;
      }
      .seniorclass-detail-info{
        margin-top: 20px;
        font-size: 18px;
        line-height: 33px;
        color: #4b7bbe;
        span{
          margin-right: 30px;
        }
      }
      .detail-cont{
        margin-top: 30px;
        padding-right: 22px;
        font-size: 24px;
        line-height: 42px;
        text-align: justify;
        color: #333333;
      }
      .detail-back{
        width: 200px;
        height: 60px;
        margin: 98px auto 20px;
        border-radius: 6px;
        background-color: #eb6420;
        font-size: 24px;
        line-height: 60px;
        text-align: center;
        color: #ffffff;
      }
    }
  }
  @media screen and (max-width: 1300px){
    .seniorclass-detail{
      padding: 0 30px;
      .seniorclass-detail-cont{
        .seniorclass-detail-item{
          margin-top: 30px;
        }
      }
    }
  }
  @media screen and (max-width: 1200px){
    .seniorclass-detail{
      width: 100%;
      margin-bottom: 20px;
      padding: 0 15px;
      border-radius: 3px;
      .seniorclass-detail-cont{
        padding: 0 0 40px;
        .seniorclass-detail-item{
          margin-top: 30px;
          font-size: 18px;
          line-height: 18px;
        }
        .seniorclass-detail-info{
          margin-top: 10px;
          font-size: 12px;
          line-height: 16px;
          span{
            margin-right: 15px;
          }
        }
        .detail-cont{
          margin-top: 15px;
          padding-right: 11px;
          font-size: 12px;
          line-height: 21px;
        }
        .detail-back{
          width: 100px;
          height: 30px;
          margin: 49px auto 10px;
          border-radius: 3px;
          font-size: 12px;
          line-height: 30px;
        }
      }
    }
  }
</style>
<style lang="less">
  .detail-cont{
    img,iframe,video{
      max-width: 100%;
    }
  }
</style>
